<template>
  <div class="panel-list-page">
    <div class="pl-card">
      <div class="pl-card__header">
        <div class="pl-card__title-wrap">
          <span class="pl-card__icon" aria-hidden="true">
            <CIcon name="iconList"/>
          </span>
          <div>
            <h1 class="pl-card__title">آیتم‌های ویژگی</h1>
            <p v-if="property_title" class="pl-card__sub">{{ property_title }}</p>
          </div>
        </div>
        <div class="pl-toolbar">
          <button type="button" class="pl-btn pl-btn--primary" @click="openCreateModal()">
            <CIcon name="iconPlus"/>
            <span>افزودن آیتم جدید</span>
          </button>
        </div>
      </div>

      <div class="pl-card__body">
        <CDataTableFixed
          :items="items"
          :fields="fields"
          :items-per-page="20"
          hover
          sorter
          pagination
          :noItemsView="{ noItems: 'آیتمی یافت نشد' }"
        >
          <template #no-items-view>
            <div class="pl-empty">
              <span class="pl-empty__icon" aria-hidden="true">
                <CIcon name="iconList"/>
              </span>
              <p class="pl-empty__title">آیتمی یافت نشد</p>
              <p class="pl-empty__sub">برای این گروه، یک آیتم ویژگی اضافه کنید.</p>
              <button type="button" class="pl-btn pl-btn--primary" @click="openCreateModal()">
                <CIcon name="iconPlus"/>
                <span>افزودن آیتم جدید</span>
              </button>
            </div>
          </template>

          <template #row="{ item }">
            <td>
              <span class="pl-muted">{{ item.row_id + 1 }}</span>
            </td>
          </template>

          <template #نام="{ item }">
            <td>
              <span class="pl-name">{{ item.title.title }}</span>
            </td>
          </template>

          <template #عملیات="{ item }">
            <td class="pl-ops-cell">
              <div class="pl-ops">
                <button
                  type="button"
                  class="pl-icon-btn pl-icon-btn--warn"
                  title="ویرایش"
                  @click="openEditModal(item)"
                >
                  <CIcon name="iconEdit"/>
                </button>
                <button
                  type="button"
                  class="pl-icon-btn pl-icon-btn--danger"
                  title="حذف"
                  @click="delete_dialog(item)"
                >
                  <CIcon name="iconTrash"/>
                </button>
              </div>
            </td>
          </template>
        </CDataTableFixed>
      </div>
    </div>

    <CModal
      :show.sync="form_modal"
      :centered="true"
      size="lg"
      :title="status_form == 0 ? 'افزودن آیتم جدید' : 'ویرایش آیتم'"
      @update:show="onFormModalToggle"
    >
      <div class="pl-form">
        <CRow>
          <CCol col="12">
            <CInput
              v-model="name"
              class="required"
              label="نام آیتم"
              placeholder="نام آیتم"
            />
          </CCol>
        </CRow>
      </div>
      <template #footer>
        <button type="button" class="pl-btn pl-btn--ghost" @click="closeFormModal()">انصراف</button>
        <button type="button" class="pl-btn pl-btn--primary" @click="login()">
          <CIcon name="iconCheck"/>
          <span>{{ status_form == 0 ? 'ثبت آیتم' : 'ذخیره تغییرات' }}</span>
        </button>
      </template>
    </CModal>
  </div>
</template>

<script>
import axios from "axios";
import {bus} from "../../../main";


export default {
  name: 'Login',
  data() {
    return {
      form_modal: false,
      confirm_delete_name:new Date().getTime()+"_"+this.$vnode.tag,

      property_title: '',
      name: '',
      file: '',
      color: '',
      previewImage: '',
      description: '',
      items: [],
      fields: [
        {key: 'row',label: '#', _style: 'width:10%'},
        {key: 'نام', _style: 'width:10%'},

        {key: 'عملیات', _style: 'width:40%;'},


      ],
      status_form: 0
    }
  }, mounted() {
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == 'true') {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
    this.get_categories();
  }, watch: {},
  methods: {
    openCreateModal() {
      this.cancel_form();
      this.form_modal = true;
    },
    openEditModal(item) {
      this.editDetails(item);
      this.form_modal = true;
    },
    closeFormModal() {
      this.form_modal = false;
      this.cancel_form();
    },
    onFormModalToggle(show) {
      if (!show) {
        this.cancel_form();
      }
    },
    cancel_form() {
      this.name = '';
      this.status_form = 0;
    },

    editDetails(item) {
      this.name = item.title.title;

      this.status_form = item.id;

    }, get_categories() {
      var self = this;
      var formData = new FormData();
      formData.append("id", +this.$route.params.group_id)
      axios.post('/api/admin/product/get_property_items', formData, {}).then(function (response) {

        var content_cats = response.data;
self.property_title = response.data.msg
        self.items = content_cats.tags.map((item, row_id) => {
          return {...item, row_id}
        });

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    goRegister() {
      this.$router.push({path: 'register'});
    },

    login() {


      let self = this;
      const formData = new FormData()
      let url;
      if (this.status_form == 0) {
        url = "/api/admin/product/add_property_item";
      } else {
        url = "/api/admin/product/update_property_item";
        formData.append('id', this.status_form)

      }

      formData.append('name', this.name);
      formData.append('group_id', this.$route.params.group_id);

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);

          self.status_form = 0;
          self.name = '';
          self.form_modal = false;

          self.get_categories();


      })


          .catch(function (error) {

            console.log(error);
          });

    },
    delete_dialog(item) {
      this.$root.modal_component.show_confirm_modal('اخطار', "آیا مایل به حذف این ردیف هستید؟", ['تایید'], this.confirm_delete_name);


      this.status_form = item.id;
      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },
    delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "/api/admin/product/delete_property_item";


      formData.append('id', this.status_form);

      axios.post(url, formData, {}).then((res) => {
        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;

        self.get_categories();


      })
          .catch(function (error) {

            console.log(error);
          });
    },


  }
}


</script>
